import IFrameNav from "components/Navigation/IFrameNav";
import { Outlet } from "react-router-dom";

export default function IFrame() {
    return (
        <>
            <IFrameNav />
            <div className="cc-iframe">
                <Outlet />
            </div>
        </>
    )
}